import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import "../../styles/projectStyles/AdditionalDetails.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { openDB } from "idb";

const AdditionalDetailsService = ({ data, setData, files, setFiles }) => {
  const getFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    
    switch (extension) {
      case "pdf":
        return "images/icons/pdf.png";
      case "doc":
      case "docx":
        return "images/icons/doc.png";
      case "jpeg":
      case "jpg":
      case "png":
        return "images/icons/image.png";
      case "mp4":
      case "mov":
      case "avi":
        return "images/icons/video.png";
      default:
        return "images/icons/document.png";
    }
  };

  // // Initialize IndexedDB and load files on mount
  // useEffect(() => {
  //   const loadFilesFromDB = async () => {
  //     const db = await openDB("fileStorage", 1, {
  //       upgrade(db) {
  //         db.createObjectStore("files", { keyPath: "name" });
  //       },
  //     });
  //     const storedFiles = await db.getAll("files");
  //     setFiles(storedFiles);
  //     localStorage.setItem("uploadedFiles", JSON.stringify(storedFiles));
  //   };
  //   loadFilesFromDB();
  // }, [setFiles]);

  // Save files to IndexedDB and local storage whenever files state changes
  // useEffect(() => {
  //   const saveFiles = async () => {
  //     const db = await openDB("fileStorage", 1);
  //     const tx = db.transaction("files", "readwrite");
  //     await tx.store.clear();
  //     files.forEach(async (file) => {
  //       await tx.store.add(file);
  //     });
  //     await tx.done;
  //     localStorage.setItem("uploadedFiles", JSON.stringify(files));
  //   };
  //   saveFiles();
  // }, [files]);

  // Handle file uploads
  const onDrop = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) => ({
      file,
      image: getFileIcon(file.name),
      name: file.name,
      size: `${(file.size / 1024).toFixed(2)} KB`,
      progress: 0,
    }));
    const updatedFiles = [...files, ...newFiles];
    setFiles(updatedFiles);
  };

  // Handle delete action
  const handleDelete = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className="additional-details-container">
      <div className="additionaldetailsScr">
        <div className="additionaldetails-header-container">
          <h3 className="title">Additional Details</h3>
          <div className="attachments-container">
            <img
              src="/images/attachment.png"
              alt="Attachment Icon"
              className="attachment-icon"
            />
            <label className="sub-title">Attachments</label>
          </div>
          <div className="form-container">
            <div className="row" {...getRootProps({ className: "dropzone" })}>
              <input {...getInputProps()} />
              <div className="upload-box">
                <img
                  src="/images/uploads.svg"
                  alt="Upload Icon"
                  className="upload-icon"
                />
                <p>Drag or Click to Upload</p>
                <p>PDF, Jpeg, or PNG Files</p>
              </div>
            </div>
            <div className="row">
              <div className="file-list">
                {files.map((file, index) => (
                  <div key={index} className="file-item">
                    <img
                      src={file.image}
                      alt={`${file.name} preview`}
                      className="file-preview"
                    />
                    <span className="file-name">{file.name}</span>
                    <span className="file-size">{file.size}</span>
                    <div style={{ width: 50, height: 50 }}>
                      <CircularProgressbar
                        className="circular-progress"
                        value={file.progress}
                        text={`${file.progress}%`}
                        styles={buildStyles({
                          textSize: "32px",
                          pathColor: "#d72c16",
                          textColor: "#333",
                          trailColor: "#f0f0f0",
                        })}
                      />
                    </div>
                    <img
                      src="/images/bin.png"
                      alt="Delete Icon"
                      className="del-icon"
                      onClick={() => handleDelete(index)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalDetailsService;
